// extracted by mini-css-extract-plugin
module.exports = {"manualTagEntry":"manualTagEntry_manualTagEntry__2HAZg","notes":"manualTagEntry_notes__36YZj"};